import $ from 'jquery';
import { windowWatcher } from './components/window-watcher';
import { toggleNav } from './components/toggle-nav';
import { toggleView } from './components/toggle-view';
import { filters } from './components/filters';
import { collapsibleSections } from './components/collapsible-sections';
import { masonry } from './components/masonry';
import { slider } from './components/slider';
import { map } from './components/map';

window.main = window.main || {};

const $body = $('body');

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;
let isGalleryToggled = false;
let isHeaderTransparent = false;
let isHeaderScrollState = false;

main.init = () => {

  function checkIfTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }
  if(checkIfTouchDevice() === true) {
    $body.addClass('is-touch');
    $body.addClass('is-mobile-device');
    isTouchDevice = true;
  }
  else {
    isTouchDevice = false;
  }

  // listen to window resize event
  windowWatcher();
  toggleNav();
  toggleView();
	filters();
  collapsibleSections();
	masonry('.js-flexible-grid');
  slider('.js-slider',isTouchDevice);
  map('.js-map');

	main.bindEvents();

};

main.bindEvents = function() {

  $('.js-anchor-link').on('click', function(evt) {
		evt.preventDefault();
    if(isNavToggled) {
      main.toggleNav();
    }
    main.scrollTo($(this).attr('href'));
	});

  $('.js-push').on('click', function(evt) {
		evt.preventDefault();
    main.scrollTo('.js-wrap');
	});

  var $btnToggleListItem =	$('.js-toggle-list-item-button');

  $btnToggleListItem.on('click', function(evt) {
		evt.preventDefault();
		main.toggleListItem($(this));
	});

}

main.toggleListItem = function(listItem) {

  listItem.closest('.js-toggle-list-item').toggleClass('is-toggled');

};


main.scrollTo = function(href) {

	$('html:not(:animated), body:not(:animated)').animate({
		scrollTop: $(href).offset().top + 1
	}, 550);

	$('html,body').on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function(){
		$('html,body').stop();
	});

};

$(main.init);
